import { FC } from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'common/hooks/useTranslation';
import { styles } from './InstallationBanner.styles';

export type InstallationBannerProps = {
  onClick?: () => void;
};
export const InstallationBanner: FC<InstallationBannerProps> = ({ onClick }) => {
  const { t } = useTranslation();

  return (
    <Box sx={styles.bannerBackground} role="button" tabIndex={0} onClick={onClick} onKeyDown={onClick}>
      <Typography variant="subtitle2" sx={styles.bannerText}>
        {t('installation.ongoing')}
      </Typography>
    </Box>
  );
};
